import React from 'react';
import {
  ADD_MODULE_PAGE,
  MODULE_MANAGEMENT_PAGE,
  addCustomExtension,
} from '../../../../constants';
import { RouteContext } from '../../../../context';
import { BreadCrumbBase, BreadCrumbItem } from '../../../UI/BreadCrumbBase';
import {
  EditModulePageQueryParams,
  useEditingModule,
} from './useEditingModule';
import { getCustomModuleCard } from '../AddModule/customModuleCards';

const SetupModuleBreadCrumbs = () => {
  const { query } = React.useContext(RouteContext);
  const { moduleId, preset = '' } = query as EditModulePageQueryParams;
  const [breadCrumbsItems, setBreadCrumbsItems] = React.useState<
    Array<BreadCrumbItem>
  >([]);
  const editingModule = useEditingModule();
  const customModuleCard = getCustomModuleCard(preset);

  /**
   * This hook is used to get the breadcrumbs items for the current page.
   * When moduleId === new then it will return the breadcrumbs for the new module page.
   * When moduleId !== new then it will return the breadcrumbs for the edit module page.
   */
  React.useEffect(() => {
    // initial breadcrumbs items
    let items = [
      {
        label: 'Apps',
        path: MODULE_MANAGEMENT_PAGE.path,
      },
    ];

    // getting bread crumbs items when it is create module flow
    if (moduleId === 'new') {
      items = items.concat([
        {
          label: ADD_MODULE_PAGE.label,
          path: ADD_MODULE_PAGE.path,
        },
        {
          label: `Add ${
            customModuleCard ? customModuleCard.name : addCustomExtension
          }`,
          path: '',
        },
      ]);
      setBreadCrumbsItems(items);
      return;
    }

    // getting bread crumbs items when it is edit module flow
    if (editingModule) {
      // if the module is disabled, it should show Enable instead of Edit.
      // This is the scenario when we're enabling a core module.
      if (editingModule.disabled) {
        items = items.concat([
          {
            label: ADD_MODULE_PAGE.label,
            path: ADD_MODULE_PAGE.path,
          },
          {
            label: `Enable ${editingModule.label}`,
            path: '',
          },
        ]);
      } else {
        items.push({
          label: `Edit ${editingModule.label}`,
          path: '',
        });
      }

      setBreadCrumbsItems(items);
    }
  }, [editingModule]);

  return <BreadCrumbBase items={breadCrumbsItems} />;
};

export default SetupModuleBreadCrumbs;
